import { DOCK_CHAT_OPENED, DOCK_CHAT_CLOSED, DOCK_CHAT_MESSAGE_SHOWN } from 'react/redux/actions/dockChat';

// The dock's chat sheet: open or not, the conversation it shows (kept while
// closed, so it reopens there) and a message to scroll to once.
const initialState = {
	open: false,
	conversation: null,
	focusMessageId: null,
};

export default (state = initialState, action) => {
	switch(action.type) {
		case DOCK_CHAT_OPENED: {
			const { conversation, messageId } = action.payload;
			return {
				open: true,
				conversation: conversation || state.conversation,
				focusMessageId: messageId || null,
			};
		}
		case DOCK_CHAT_CLOSED:
			return { ...state, open: false, focusMessageId: null };
		case DOCK_CHAT_MESSAGE_SHOWN:
			return { ...state, focusMessageId: null };
		default:
			return state;
	}
};
